/* eslint-disable @typescript-eslint/no-unused-vars */
import { CloseButton } from '@descomplica/uee-ui-components';
import React from 'react';

import Certificate from '@/presentation/screens/certificate/certificate';

interface CertificateProps {
  mobileSidebarOpen: boolean;
  title: string;
  onClose: () => void;
  certificateUrl?: string;
}

export const CertificateContainer = ({ mobileSidebarOpen, title, onClose }: CertificateProps) => (
  <div className={`current-lesson ${mobileSidebarOpen ? 'hidden' : ''}`}>
    <div className="current-lesson-header">
      <h3 className="lesson-heading">{title}</h3>
      <div className="current-lesson-actions">
        <CloseButton onClick={onClose} ariaLabel="Fechar certificado" tabIndex={1} />
      </div>
    </div>
    <Certificate />
  </div>
);
